import { render, staticRenderFns } from "./FavoritesBtn.vue?vue&type=template&id=374b359c&scoped=true"
import script from "./FavoritesBtn.vue?vue&type=script&lang=js"
export * from "./FavoritesBtn.vue?vue&type=script&lang=js"
import style0 from "./FavoritesBtn.vue?vue&type=style&index=0&id=374b359c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b359c",
  null
  
)

export default component.exports